function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.229 13.342l-11.595-11.595c-0.436-0.436-1.016-0.677-1.633-0.677s-1.197 0.24-1.633 0.677l-2.528 2.528h-3.835v3.834l-5.332 5.331v17.491h26.656v-17.489l-0.099-0.099zM28.125 13.747l-4.129 4.129v-8.257l4.129 4.129zM15.121 2.5c0.47-0.47 1.289-0.47 1.759 0l1.774 1.774h-5.307l1.774-1.774zM19.719 5.34l3.211 3.212v10.39l-2.469 2.469-2.829-2.829c-0.436-0.436-1.016-0.677-1.633-0.677s-1.197 0.241-1.633 0.677l-2.871 2.87-2.426-2.426v-13.685h10.649zM4.38 13.24l3.624-3.624v8.343l-4.172-4.172 0.548-0.548zM3.738 16.058v-0.856l7.003 7.003-0.079 0.080-0.001-0.001-6.923 6.923v-13.149zM4.589 29.864l0.573-0.573h0.002l9.957-9.956c0.47-0.47 1.289-0.47 1.759 0l10.531 10.529h-22.822zM28.262 15.36v13.848l-7.046-7.043 7.046-7.046v0.242z",
  fill: "#000000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.268 8.539h7.464v1.066h-7.464v-1.066z",
  fill: "#000000"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.268 14.937h7.464v1.066h-7.464v-1.066z",
  fill: "#000000"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.268 11.738h5.331v1.066h-5.331v-1.066z",
  fill: "#000000"
});

var SvgMailOpenFile = function SvgMailOpenFile(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMailOpenFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-open-file.b7e91846.svg";
export { ForwardRef as ReactComponent };